<template>
    <div class="ItemModalContainer">
        <div class="modal">
            <div class="modalForm" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" >
                <header class="modal-header" id="modalTitle">
                    <slot name="header"></slot>
                    <button type="button" class="btn-close" @click="close" aria-label="Close modal">x</button>
                </header>
                <section class="modal-body" id="modalDescription">
                    <slot name="body"></slot>
                </section>
                <footer class="modal-footer">              
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'GeneralModal',
    methods: {
        close: function() {
            this.$emit('close');
        }
    }
}
</script>

<style scoped src="@/assets/css/shared/itemModal.css"></style>
<style scoped>
  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }
  </style>